import Version from 'addressSearch/version'

// NOTE: This pack is also embedded on pages served from another origin. It no
// longer needs to rewrite the public path (as it did with webpack): the built
// entrypoint is an ES module and references its chunks relatively, so they are
// resolved against the origin the entrypoint itself was loaded from.

const selector = document.querySelectorAll('div[data-widget="address-search"]')

const element = document.documentElement
const locale = ((element && element.lang) || 'de-CH').substr(0, 2)

import('addressSearch/index').then((module) => {
  const { initializeApp } = module

  selector.forEach((rootElement) => {
    initializeApp(rootElement, locale)
  })

  // this covers the behaviours/add_element i.e "+ add one more"
  document.addEventListener('updateElement', (e) => {
    if (e.target.dataset.widget == 'address-search') {
      initializeApp(e.target, locale)
    }
  })
})

window.atpWidgetVersions = window.atpWidgetVersions || []
window.atpWidgetVersions.push({
  name: 'address-search',
  version: Version
})
